<template>
  <v-dialog
    v-model="isOpened"
    width="400px"
  >
    <v-card>
      <v-card-title>Confirmation</v-card-title>
      <v-card-text class="pa-6">
        {{ $text }}
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <v-btn text @click="answer(`no`)" v-if="!loading">Non</v-btn>
        <v-btn ref="yesBtn" depressed color="primary darken-1" :loading="loading" @click="answer(`yes`)">Oui</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: `ConfirmDialog`,
  props: {
    value: Boolean,
    text: String,
    waitAfterAnswer: Boolean,
    loading: Boolean,
  },
  data: () => ({
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) { return this.$emit(`input`, isOpened); },
    },
    $text() {
      if (!this.text) {
        return `Êtes-vous sûr ?`;
      }

      return this.text;
    },
  },
  methods: {
    answer(answer) {
      this.$emit(answer);
      if (!this.waitAfterAnswer) {
        setTimeout(() => { this.isOpened = false; }, 10);
      }
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        setTimeout(() => this.$refs.yesBtn.$el.focus(), 100);
      }
    },
  },
};
</script>
